import { RewardFeatureCard } from "./RewardFeatureCard";
import { RewardsPreviewCard } from "./RewardsPreviewCard";

const featureCards = [
  {
    icon: "/images/rewards1.svg",
    title: "Reward Loyal Customers",
    description: "Turn first-time visitors into regulars",
  },
  {
    icon: "/images/users1.svg",
    title: "Grow Your Community",
    description: "Connect with locals who support you",
  },
];

const transactions = [
  {
    title: "Coffee at Café Luna",
    time: "2 hours ago",
    points: "+50",
  },
  {
    title: "Haircut at Style Studio",
    time: "Yesterday",
    points: "+100",
  },
  {
    title: "Pizza at Tony's",
    time: "2 days ago",
    points: "+75",
  },
];

export const CommunityRewardsSection = () => {
  return (
    <div>
      <div className="hidden lg:block px-6">
         <section className="w-full flex justify-center py-12 bg-[#FAFAFA]">
      <div className="w-full max-w-[1700px] px-6">
        <div
          className="
            rounded-[34px]
            bg-white
            shadow-[0px_8px_28px_rgba(0,0,0,0.05)]
            px-9 md:px-10 lg:px-12
            py-10 md:py-12
          "
        >
          <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-10 items-end">
            {/* left content */}
            <div>
              <div className="flex items-center gap-3 text-[#2A2A2A]">
                <span className="w-[14px] h-[14px] rounded-full bg-[#D90000]" />
                <span className="text-[16px] font-medium">Community Rewards</span>
              </div>

              <h2 className="mt-8 text-[#171717] text-[54px] leading-[1.08] font-medium tracking-[-1.2px]">
                A Built-In Community 
                <br />
                <span className="text-red-600"> Rewards Program</span>
              </h2>

              <p className="mt-6 text-[#2B2B2B] text-[18px] leading-[1.45] max-w-[470px]">
                Reward customers with Coupon Points. They earn points city-wide and spend them directly on your offers, creating a powerful local loyalty loop.
              </p>

              <div className="mt-10 space-y-5 max-w-[470px]">
                {featureCards.map((card, index) => (
                  <RewardFeatureCard
                    key={index}
                    icon={card.icon}
                    title={card.title}
                    description={card.description}
                  />
                ))}
              </div>
            </div>

            {/* right preview */}
            <RewardsPreviewCard transactions={transactions} />
          </div>
        </div>
      </div>
    </section>
      </div>

      <div className="block lg:hidden">
         <section className="w-full flex justify-center py-8 bg-[#F9F0F0]">
      <div className="w-full max-w-[1700px] px-6">
        <div
          className="
            
            
             
           
          "
        >
          <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-10 items-center">
            {/* left content */}
            <div>
               <div className="flex justify-start items-center gap-3 text-gray-600 mb-6">
          <span className="w-2.5 h-2.5 bg-red-600 rounded-full"></span>
          <span className="text-[16px]">Community Rewards</span>
        </div>

              

              <h2 className="mt-6 text-[#171717] text-[30px] leading-[1.08] font-medium tracking-[-1.2px]">
                A Built-In Community 
                <br />
                <span className="text-red-600"> Rewards Program</span>
              </h2>

              <p className="mt-6 text-[#2B2B2B] text-[12px] leading-[1.45] max-w-[470px]">
                Reward customers with Coupon Points. They earn points city-wide and spend them directly on your offers, creating a powerful local loyalty loop.
              </p>

              <div className="mt-10 space-y-5 max-w-[470px]">
                {featureCards.map((card, index) => (
                  <RewardFeatureCard
                    key={index}
                    icon={card.icon}
                    title={card.title}
                    description={card.description}
                  />
                ))}
              </div>
            </div>

            {/* right preview */}
            <RewardsPreviewCard transactions={transactions} />
          </div>
        </div>
      </div>
    </section>
      </div>
    </div>
   
  );
};